import React from "react";

export const CARE_HOME_TYPES = [
  "Nursing", "Residential", "Dementia", "Learning disabilities",
  "Hospice", "Hospital", "Community care", "Assisted living", "Other",
];

export function StatCard({ label, value, sub, icon: Icon, tone = "brand", testid }) {
  const tones = {
    brand: "text-brand", coral: "text-coral", green: "text-rag-green",
    amber: "text-rag-amber", red: "text-rag-red",
  };
  return (
    <div data-testid={testid} className="bg-cream-card border border-cream-deep rounded-xl p-5 transition-transform duration-150 hover:-translate-y-1 hover:shadow-md">
      <div className="flex items-start justify-between">
        <div>
          <div className="label-caps text-muted-foreground">{label}</div>
          <div className={`text-3xl font-bold mt-2 font-heading ${tones[tone]}`}>{value}</div>
          {sub && <div className="text-sm text-muted-foreground mt-1">{sub}</div>}
        </div>
        {Icon && <Icon className={`h-5 w-5 ${tones[tone]}`} />}
      </div>
    </div>
  );
}

export function RagBadge({ status }) {
  const map = {
    green: "bg-rag-green-bg text-rag-green", amber: "bg-rag-amber-bg text-rag-amber",
    red: "bg-rag-red-bg text-rag-red",
  };
  const label = { green: "On track", amber: "Needs attention", red: "At risk" };
  return (
    <span data-testid={`rag-${status}`} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${map[status]}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${status === "green" ? "bg-rag-green" : status === "amber" ? "bg-rag-amber" : "bg-rag-red"}`} />
      {label[status]}
    </span>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-brand tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1 text-sm md:text-base">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}
